import styled from "styled-components";

import { ContentContainer } from "uikit";

export const Container = styled(ContentContainer)`
  margin-bottom: 60px;
`;

export const FormContainer = styled.form``;
